import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";

import { ITreasureContract,NFTContarct } from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import NFTABI from "../abis/NFTABI.json";

import { FaWallet, FaCopy, FaCheck } from "react-icons/fa";
import Loader from "../components/Loader";
import Nodata from "../assets/img/no-record-found.png";

const AllRoyaltyuser = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [royaltyData, setRoyaltyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [burnCountMap, setBurnCountMap] = useState({});

  // ⭐ ROYALTY POOL MAPPING
  const royaltyPoolAmount = {
    1: 400,
    2: 600,
    3: 1000,
    4: 1500
  };

    // 🔥 Burn qualification rule (SINGLE SOURCE)
  const isBurnQualified = (rank, burned) => {
    if (rank === 1) return burned >= 3;
    if (rank === 2) return burned >= 6;
    if (rank === 3) return burned >= 9;
    if (rank === 4) return burned >= 15;
    return false;
  };

  // Initialize Web3
  useEffect(() => {
    let provider = null;

    if (client?.transport) provider = client.transport;
    else if (window.ethereum) provider = window.ethereum;

    if (provider) {
      setWeb3(new Web3(provider));
    }
  }, [client]);

  // Fetch Royalty Rank Users
 const fetchRoyaltyUsers = async () => {
    if (!web3) return;
    setLoading(true);

    try {
      const royaltyContract = new web3.eth.Contract(
        ITreasureContractABI,
        ITreasureContract
      );

      const nftContract = new web3.eth.Contract(
        NFTABI,
        NFTContarct
      );

      const allRanks = [];
      const burnMap = {};

      for (let rank = 1; rank <= 4; rank++) {
        const result = await royaltyContract.methods
          .getAllRoyaltyRankUsers(rank)
          .call();

        const usersWithStatus = [];

        for (let i = 0; i < result.users.length; i++) {
          const userAddr = result.users[i];
          if (
            userAddr ===
            "0x0000000000000000000000000000000000000000"
          )
            continue;

          const burned = Number(
            await nftContract.methods.getBurnToken(userAddr).call()
          );

          burnMap[userAddr] = burned;

          usersWithStatus.push({
            address: userAddr,
            burned,
            status: isBurnQualified(rank, burned)
              ? "Qualified"
              : "Not Qualified",
          });
        }

        allRanks.push({
          rank,
          users: usersWithStatus,
          totalUsers: usersWithStatus.length,
          qualifiedCount: usersWithStatus.filter(
            (u) => u.status === "Qualified"
          ).length,
        });
      }

      setBurnCountMap(burnMap);
      setRoyaltyData(allRanks);
    } catch (err) {
      console.error("Royalty Fetch Error:", err);
    }

    setLoading(false);
  };

//  const fetchRoyaltyUsers = async () => {
//     if (!web3) return;
//     setLoading(true);

//     try {
//       const royaltyContract = new web3.eth.Contract(
//         ITreasureContractABI,
//         ITreasureContract
//       );

//       const nftContract = new web3.eth.Contract(
//         NFTABI,
//         NFTContarct
//       );

//       const allRanks = [];
//       const burnMap = {};

//       for (let rank = 1; rank <= 4; rank++) {
//         const result = await royaltyContract.methods
//           .getAllRoyaltyRankUsers(rank)
//           .call();

//         // 🔥 Fetch burn count for each user
//         for (let i = 0; i < result.users.length; i++) {
//           const userAddr = result.users[i];

//           if (
//             userAddr !== "0x0000000000000000000000000000000000000000" &&
//             burnMap[userAddr] === undefined
//           ) {
//             try {
//               const burn = await nftContract.methods
//                 .getBurnToken(userAddr)
//                 .call();

//               burnMap[userAddr] = Number(burn);
//             } catch {
//               burnMap[userAddr] = 0;
//             }
//           }
//         }

//         allRanks.push({
//           rank: rank,
//           userCount: Number(result.userCount),
//           users: result.users,
//         });
//       }

//       setBurnCountMap(burnMap);
//       setRoyaltyData(allRanks);
//     } catch (err) {
//       console.error("Royalty Fetch Error:", err);
//     }

//     setLoading(false);
//   };


  useEffect(() => {
    if (isConnected && web3) fetchRoyaltyUsers();
  }, [isConnected, web3]);

  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);

    setTimeout(() => setCopiedIndex(null), 1500);
  };

  if (loading) return <Loader />;



 return (
    <div className="buyshheikh-page">
      <h4 className="mb-3 mobilefiltername">
        <div>
         <span className="text-warning">All Royalty</span>{" "}
          <span className="fw-lighter">Users</span>
        </div>
      </h4>

      <div className="card paddingfilter">
        <div className="card-body">
          {royaltyData.length > 0 ? (
            royaltyData.map((rankObj, rIndex) => (
              <div className="mb-4" key={rIndex}>
                {/* 🔹 Rank Header */}
                <div className="text-white mb-2">
                  Royalty Pool:{" "}
                  <b className="text-warning">
                    {royaltyPoolAmount[rankObj.rank]} USDT
                  </b>{" "}
                  | Total Users:{" "}
                  <b className="text-warning">
                    {rankObj.totalUsers}
                  </b>{" "}
                  | Qualified:{" "}
                  <b className="text-success">
                    {rankObj.qualifiedCount}
                  </b>
                </div>

                <div className="row">
                  {rankObj.users.map((user, idx) => {
                    const addr = user.address;
                    const masked = `${addr.slice(0, 6)}...${addr.slice(-4)}`;

                    return (
                      <div className="col-md-4 mb-3 mt-3" key={idx}>
                        <div className="ref-card">
                          <div className="ref-card-body">
                            <span className="ref-label">
                              <FaWallet className="ref-icon" /> Address
                            </span>

                            <div className="ref-copy-box">
                              <span className="ref-value">{masked}</span>
                              <button
                                className="copy-btn"
                                onClick={() =>
                                  handleCopy(addr, `${rIndex}-${idx}`)
                                }
                              >
                                {copiedIndex === `${rIndex}-${idx}` ? (
                                  <FaCheck className="copy-icon copied" />
                                ) : (
                                  <FaCopy className="copy-icon" />
                                )}
                              </button>
                            </div>

                            {/* 🔥 Burn Count */}
                            <div
                              style={{
                                fontSize: "12px",
                                marginTop: "6px",
                                color: "#ff9800",
                                fontWeight: "500",
                              }}
                            >
                              Burned NFTs: {user.burned}
                            </div>

                            {/* ✅ STATUS */}
                            <div
                              style={{
                                fontSize: "12px",
                                marginTop: "4px",
                                fontWeight: "600",
                                color:
                                  user.status === "Qualified"
                                    ? "#16c784"
                                    : "#d9534f",
                              }}
                            >
                              Status: {user.status}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <hr />
              </div>
            ))
          ) : (
            <div className="no-data">
              <img src={Nodata} alt="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllRoyaltyuser;
